"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BlitzInfoConfig = exports.BlitzInfo = void 0;
var _pixi = require("pixi.js");
var _core = require("@dragon/core");
var _pixiGame = require("@dragon/pixi-game");
var _gsap = _interopRequireDefault(require("gsap"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BlitzInfoConfig = exports.BlitzInfoConfig = /*#__PURE__*/_createClass(function BlitzInfoConfig() {
  _classCallCheck(this, BlitzInfoConfig);
  /**Sprite offset on y */
  _defineProperty(this, "mYOffset", void 0);
  /**Whole blitz info bar offset on y */
  _defineProperty(this, "yOffSet", void 0);
  _defineProperty(this, "spriteScale", void 0);
  _defineProperty(this, "spriteName", void 0);
  /**No bg on the game info. might be the game has none. */
  _defineProperty(this, "noSprite", void 0);
  /**
   * Override default styling.
   */
  _defineProperty(this, "style", void 0);
  /**
   * Offset the icon on the y axis. usefull for overrideing with with custom fonts.
   */
  _defineProperty(this, "iconYOffset", void 0);
});
var BlitzInfo = exports.BlitzInfo = /*#__PURE__*/function (_CustomPixiContainer) {
  function BlitzInfo(parent, blitzInfoConfig) {
    var _this$_blitzInfoConfi4, _blitzInfoConfig$mYOf, _this$_blitzInfoConfi5, _this$_blitzInfoConfi6;
    var _this;
    _classCallCheck(this, BlitzInfo);
    _this = _callSuper(this, BlitzInfo);
    _defineProperty(_this, "sprite", void 0);
    _defineProperty(_this, "infoText", void 0);
    _defineProperty(_this, "idleContainer", void 0);
    _defineProperty(_this, "textStyle", void 0);
    _defineProperty(_this, "_blitzInfoConfig", void 0);
    _defineProperty(_this, "setSpecial", function (s) {
      if (_this.idleContainer.children.length > 0) {
        var children = _this.idleContainer.children;
        _this.idleContainer.removeChildren();
        for (var i in children) {
          children[i].destroy();
        }
      }
      var asset = "play_blitz.png";
      switch (s) {
        case _core.StatusTextState.BlitzStop:
          asset = "play_blitz_stop.png";
      }
      var specialString = _core.CORE.translate("statusText" + s);
      if (specialString.indexOf("{0}") > -1) {
        var _this$_blitzInfoConfi, _this$_blitzInfoConfi2;
        var t = specialString.split("{0}");
        var s1 = new _pixi.Sprite(_pixi.Texture.from(asset));
        s1.scale.set(0.9);
        _this.idleContainer.addChild(s1);
        var p1, p2;
        p1 = new _pixi.Text(t[0], _this.textStyle);
        p1.y = 6;
        _this.idleContainer.addChild(p1);
        s1.x = p1.width + 6;
        s1.y = (_this$_blitzInfoConfi = (_this$_blitzInfoConfi2 = _this._blitzInfoConfig) === null || _this$_blitzInfoConfi2 === void 0 ? void 0 : _this$_blitzInfoConfi2.iconYOffset) !== null && _this$_blitzInfoConfi !== void 0 ? _this$_blitzInfoConfi : 0;
        p2 = new _pixi.Text(t[1], _this.textStyle);
        p2.y = 6;
        p2.x = s1.x + s1.width + 6;
        _this.idleContainer.addChild(p2);
      } else {
        var _p = new _pixi.Text(specialString, _this.textStyle);
        _this.idleContainer.addChild(_p);
      }
      _this.idleContainer.x = _this.sprite.width / 2 - _this.idleContainer.width / 2;
      _this.idleContainer.y = _this.sprite.height / 2 - _this.idleContainer.height / 2;
    });
    _defineProperty(_this, "handleInfoState", function (s, coinswon) {
      _this.idleContainer.visible = false;
      _gsap["default"].killTweensOf(_this.infoText);
      _gsap["default"].killTweensOf(_this.idleContainer);
      _this.infoText.alpha = 1;
      switch (s) {
        case _core.StatusTextState.BlitzStop:
        case _core.StatusTextState.Blitz:
        case _core.StatusTextState.Idle:
          {
            _this.setSpecial(s);
            _this.infoText.alpha = 0;
            _this.idleContainer.alpha = 1;
            _this.idleContainer.visible = true;
            _gsap["default"].to(_this.idleContainer, {
              duration: 0.8,
              alpha: 0.6,
              repeat: -1,
              yoyo: true
            });
            break;
          }
        default:
          {
            _this.infoText.x = _this.sprite.width / 2;
            if (s !== undefined) _this.infoText.text = _core.CORE.translate("statusText" + s);
            break;
          }
      }
    });
    _defineProperty(_this, "handleResize", function (c) {
      var _this$_blitzInfoConfi3;
      _this.scale.set(1);
      _this.x = 0;
      _this.y = (_this$_blitzInfoConfi3 = _this._blitzInfoConfig) !== null && _this$_blitzInfoConfi3 !== void 0 && _this$_blitzInfoConfi3.yOffSet ? c.height * 0.82 + _this._blitzInfoConfig.yOffSet : c.height * 0.82;
      _this.infoText.x = _this.sprite.width / 2;
      _this.infoText.y = _this.sprite.height / 2;
      _this.idleContainer.x = _this.sprite.width / 2 - _this.idleContainer.width / 2;
      _this.idleContainer.y = _this.sprite.height / 2 - _this.idleContainer.height / 2;
      _this.pivot.x = _this.width / 2;
      _this.x = c.width / 2;
      _this.scale.set(c.scaleFactor);
    });
    _defineProperty(_this, "hide", function () {
      _gsap["default"].to(_this, {
        alpha: 0,
        duration: 0.5
      });
    });
    _defineProperty(_this, "show", function () {
      if (_this.alpha != 1) {
        _gsap["default"].to(_this, {
          alpha: 1,
          duration: 2
        });
      }
    });
    _this.name = "BlitzInfo";
    _this._blitzInfoConfig = blitzInfoConfig;
    _this.sprite = new _pixi.Sprite();
    if ((_this$_blitzInfoConfi4 = _this._blitzInfoConfig) !== null && _this$_blitzInfoConfi4 !== void 0 && _this$_blitzInfoConfi4.noSprite) {} else {
      _this.sprite.texture = _pixi.Texture.from("info_bg.png");
    }
    _this.sprite.y = (_blitzInfoConfig$mYOf = blitzInfoConfig === null || blitzInfoConfig === void 0 ? void 0 : blitzInfoConfig.mYOffset) !== null && _blitzInfoConfig$mYOf !== void 0 ? _blitzInfoConfig$mYOf : 0;
    if (blitzInfoConfig !== null && blitzInfoConfig !== void 0 && blitzInfoConfig.spriteScale) _this.sprite.scale.set(blitzInfoConfig.spriteScale);
    _this.addChild(_this.sprite);
    _this.textStyle = (_this$_blitzInfoConfi5 = (_this$_blitzInfoConfi6 = _this._blitzInfoConfig) === null || _this$_blitzInfoConfi6 === void 0 ? void 0 : _this$_blitzInfoConfi6.style) !== null && _this$_blitzInfoConfi5 !== void 0 ? _this$_blitzInfoConfi5 : {
      fill: 0xffffff,
      fontFamily: "InterMedium"
    };
    _this.infoText = new _pixi.Text("", _this.textStyle);
    _this.infoText.anchor.set(0.5, 0.5);
    _this.addChild(_this.infoText);
    _this.alpha = 0;

    //#region play button thinige
    _this.idleContainer = new _pixi.Container();
    _this.addChild(_this.idleContainer);
    //#endregion

    _core.CORE.subscribe("config.screenSize", _this.handleResize);
    _core.CORE.subscribe("ui.statusTextState", _this.handleInfoState);
    parent.addChild(_this);
    return _this;
  }
  _inherits(BlitzInfo, _CustomPixiContainer);
  return _createClass(BlitzInfo);
}(_pixiGame.CustomPixiContainer);
//# sourceMappingURL=BlitzInfo.js.map